import { CardContent, Grid, ListItem, Typography, useEventCallback } from '@mui/material';
import { Fragment, useState } from 'react';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonSIMACrumbs } from 'civil-status/constants/breadcrumb';
import {
  CivilStatusBirthUpload,
  CivilStatusDeathUpload,
  CivilStatusMarriageUpload,
  CivilStatusBirthSearch,
  CivilStatusDeathSearch,
  CivilStatusMarriageSearch,
  CivilStatusPrintFormula,
  CivilStatusStampCertificate,
  CivilStatusNotesText,
  CivilStatusDocumentRegistry,
  CivilStatusDocumentSerie,
  CivilUnionList,
  CivilStatusUnionCivilUpload,
  CitizenshipList,
} from 'shell/authorizations/civil-status';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { Link } from 'react-router-dom';
import { ListItemText } from '@mui/material';
import TableServiceMenu from './table-service-menu';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const SimaPage = (): React.ReactElement => {
  const actions = useActionAuthorization({
    nascitaCaricamento: CivilStatusBirthUpload,
    morteCaricamento: CivilStatusDeathUpload,
    matrimonioCaricamento: CivilStatusMarriageUpload,
    unioneCivileCaricamento: CivilStatusUnionCivilUpload,
    nascitaRicerca: CivilStatusBirthSearch,
    morteRicerca: CivilStatusDeathSearch,
    matrimonioRicerca: CivilStatusMarriageSearch,
    formula: CivilStatusPrintFormula,
    timbro: CivilStatusStampCertificate,
    annotazioni: CivilStatusNotesText,
    documentiRegistro: CivilStatusDocumentRegistry,
    documentiSerie: CivilStatusDocumentSerie,
    ricercaUnioneCivile: CivilUnionList,
    ricercaCittadinanza: CitizenshipList,
  });

  const [tableServiceSubmenuAnchor, setTableServiceSubmenuAnchor] = useState<null | HTMLElement>(
    null
  );

  const isTableServiceSubmenuVisible = Boolean(tableServiceSubmenuAnchor);

  const handleTableServiceMenuClick = useEventCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setTableServiceSubmenuAnchor(event.currentTarget);
  });

  const handleTableServiceSubmenuClose = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setTableServiceSubmenuAnchor(null);
  });

  const { userProfile } = useUserProfile();

  const gestioneTabelleSistema = userProfile.datiLogin?.profile?.feature?.sistema;

  return (
    <Fragment>
      <Breadcrumbs items={CommonSIMACrumbs} />
      <PmiTitle title="SIMA" paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area su cui operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {/** Autorizzazioni */}
        {actions.nascitaRicerca ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/nascita/ricerca" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti Nascita" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.matrimonioRicerca ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/matrimonio/ricerca" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti Matrimonio" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.morteRicerca ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/morte/ricerca" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti Morte" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.ricercaUnioneCivile ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/unione-civile/ricerca" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti Unione Civile" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.ricercaUnioneCivile ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/cittadinanza/ricerca" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Atti Cittadinanza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.nascitaCaricamento ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/nascita" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Caricamento Atti Nascita" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.matrimonioCaricamento ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/matrimonio" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Caricamento Atti Matrimonio" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.morteCaricamento ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/morte" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Caricamento Atti Morte" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.unioneCivileCaricamento ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/unione-civile" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Caricamento Atti Unione Civile" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.ricercaCittadinanza ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/cittadinanza" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Caricamento Atti Cittadinanza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {/* {actions.morteCaricamento ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/unione-civile" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Caricamento Atti Unione Civile" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined} */}
        {/* {actions.formula ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/formule" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Formule di stampa" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined} */}
        {(!actions.timbro &&
          !actions.documentiRegistro &&
          !actions.documentiSerie &&
          !actions.annotazioni) ||
        gestioneTabelleSistema === '0' ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleTableServiceMenuClick}>
              <CardContent>
                <TableServiceMenu
                  visibility={{
                    stamp: actions.timbro,
                    registry: actions.documentiRegistro,
                    serie: actions.documentiSerie,
                    annotation: actions.annotazioni,
                  }}
                  isSubmenuVisible={isTableServiceSubmenuVisible}
                  onClick={handleTableServiceMenuClick}
                  onClose={handleTableServiceSubmenuClose}
                  submenuAnchor={tableServiceSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {/* {actions.annotazioni ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/annotazioni" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Testo Annotazioni" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.documentiRegistro ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/registri" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registro Atto" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.documentiSerie ? (
          <Grid item xs={12} md={4}>
            <Link to="/stato-civile/serie" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Serie Atto" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined} */}
      </Grid>
    </Fragment>
  );
};

SimaPage.displayName = 'SIMA - home page component';

export default SimaPage;
